import classnames from 'classnames';
import styles from './QuantitySelector.module.css';
import goldenTicket from '../../img/golden-ticket.webp';
import { formatCurrencyUSD, getLegionImage } from '../../utils';
import Cube from '../../img/zoo/Cube.webp';

function QuantitySelector({ ...props }) {
  const {
    onClickUp,
    onClickDown,
    setMaxCubes,
    numCubes,
    currentPrice,
    horizontal,
    maxNumCubes,
    limitedInventory,
    headline,
    subHeadline,
    disableAll = false
  } = props;

  const className = classnames(styles.chooseAmount, {
    [styles.horizontal]: horizontal,
    [styles.maxNumCubes]: maxNumCubes
  });
  const maxMintClass = classnames({
    [styles.maxMintGold]: numCubes === 5,
    borderMask: numCubes === 5
  });
  const seriesDesc = headline
    ? headline + (subHeadline ? ' ' + subHeadline : '')
    : '';
  return (
    <>
      <div
        className={`${className} ${maxMintClass}`}
        id="quantity-selector"
        data-testid="quantity-selector"
      >
        <div className={styles.cubeWrapper}>
          <div className={styles.cubeWithText}>
            <img src={getLegionImage('cube') ?? Cube} alt="Cryptoys Cube" />
            {seriesDesc ? (
              <p className={styles.seriesDesc}>{seriesDesc}</p>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={styles.quantitySelectWithMessage}>
          <div className={styles.quantitySelector}>
            <button
              id="quantity-selector-down-button"
              data-testid="quantity-selector-down-button"
              className={styles.quantityButton}
              onClick={onClickDown}
              disabled={disableAll}
            >
              &#8211;
            </button>
            <button
              id="quantity-selector-up-button"
              data-testid="quantity-selector-up-button"
              className={styles.quantityButton}
              onClick={onClickUp}
              disabled={disableAll}
            >
              +
            </button>
            {numCubes && (
              <span className={`display4 ${styles.quantity}`}>{numCubes}</span>
            )}
            <button
              id="quantity-selector-max-button"
              data-testid="quantity-selector-max-button"
              className={styles.quantityButton}
              onClick={setMaxCubes}
              disabled={disableAll}
            >
              MAX
            </button>
          </div>
          {limitedInventory && (
            <span className={styles.limitedInventory}>Limited Inventory</span>
          )}
        </div>
        <div className={styles.amountWrapper}>
          <p className={styles.amountDue}>
            Amount Due <span className={styles.amountDueType}>(USD)</span>:
          </p>
          <p className={`display4 ${styles.totalAmountdue}`}>
            {formatCurrencyUSD(currentPrice)}
          </p>
        </div>
      </div>
      <div className={`${styles.goldenTicketBanner} ${maxMintClass}`}>
        <img
          className={styles.goldenTicket}
          src={goldenTicket}
          alt="Golden Ticket"
        />
        {numCubes < 5 ? (
          <p>
            Buy 5 Cryptoys at a time to get a limited edition Golden Ticket for
            early access to future drops!
          </p>
        ) : (
          <p>
            Congratulations! Complete this purchase to earn a Golden Ticket that
            will be airdropped into your Backpack later
          </p>
        )}
      </div>
    </>
  );
}

export default QuantitySelector;
